module.exports = __webpack_public_path__ + "static/media/AvenirNext-MediumItalic.9dc8d4ef.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/AvenirNext-MediumItalic.woff
// module id = 1824
// module chunks = 0